const ownDelay = 3000;

export default class OwnSlider{

    constructor(options){
        const that = this;

        /* Default Configuration
        **********************************************************/
        this.defaults = {
            touch: true,
            infinite: false,
            autoPlay: true,
            pauseOnHover: true,
            responsive: true,
            controls: true,
            arrows: true,
            caption: true,
            speed: 300,
            cssEase: 'ease-out',
        };

        this.$elem = options.element;
        this.enabled = false;


        this.ownTouch = {
            hasTouch: !!(("ontouchstart" in window) || window.DocumentTouch && document instanceof DocumentTouch),
            event: () => {
                const that = this;

                return {
                    start: (that.hasTouch) ? 'touchstart' : 'mousedown',
                    move: (that.hasTouch) ? 'touchmove' : 'mousemove',
                    end: (that.hasTouch) ? 'touchend' : 'mouseup',
                    leave: (that.hasTouch) ? 'touchleave' : 'mouseout'
                };
            }
        };

        this.init()
    }

    /* Initialization function
        **********************************************************/
    init(){
        const that = this;

        // initiate
        this.$container = this.$elem;
        this.$slider = this.$container.find('.slider');
        this.$arrows = this.$container.find('.slider__switch');
        this.$caption = this.$slider.find('.slider__caption');
        this.$slide = this.$slider.find('.slider__item');
        this.sliderStyle = this.$slider.get(0).style;
        this.slideLen = this.$slide.length;
        this.slideWidth = this.$container.outerWidth();
        this.sliderWidth = this.slideLen * this.slideWidth;
        this.current = 0;
        this.offset = 0;
        this.busy = false;
        this.touchFlag = false;
        this.$controlPanel;
        this.$navControl;
        this.timer;


        this.transformProperty = this.supportCSS3('transform');
        this.transitionProperty = this.supportCSS3('transition');
        this.has3d = this.support3d();


        // Calculate dimensions
        this._dimmensions();

        if (this.defaults.responsive) {
            $(window).on('resize.slider', () => {
                // that.throttle(that._responsive, 50); look in future throttle method
                if(that.enabled){
                    setTimeout(() => {
                        that._responsive();
                    }, 50);
                }
            });
        }

        // If caption false, hide caption
        !this.defaults.caption && this.$caption.attr('disabled', true);

        // Create nav controls
        this.defaults.controls && this._controls();

        if (this.defaults.touch) {
            // if the image img tag set attribute graggable false
            this.$slide.find('img').attr('draggable', false);
            // Binding touch events
            this._touchEnable();
        }

        if (this.defaults.autoPlay) {
            this._autoPlay();
            if (this.defaults.pauseOnHover) {
                this.$container.on('mouseenter.slider', () => {
                    clearInterval(that.timer);
                });
                this.$container.on('mouseleave.slider', () => {
                    that._autoPlay()
                });
            }
        }

        if (this.defaults.arrows) {

            // if infinite setting false hide arrows
            !this.defaults.infinite && this._stopInfinite('prev');

            this.$arrows.on('click.slider', function(e) {
                e.preventDefault();
                if (this.getAttribute('data-slider-dir') === 'next') {
                    that.show(that.current + 1);
                } else {
                    that.show(that.current - 1);
                }
            });
        } else {
            this.$arrows.attr('disabled', true);
        }

        $(window).on('resize', () => {
            $(this).trigger("resize.slider");
        });

        this.enabled = true;
    }

    supportCSS3(prop){
        let prefix = ['-webkit-', '-moz-', ''];
        let root = document.documentElement;

        function camelCase(str) {
            return str.replace(/\-([a-z])/gi, function(match, $1) {
                return $1.toUpperCase();
            });
        }
        for (let i = prefix.length - 1; i >= 0; i--) {
            let css3prop = camelCase(prefix[i] + prop);
            if (css3prop in root.style) {
                return css3prop;
            }
        }
        return false;
    }

    transitionEnd(){
        let transitions = {
            'transition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'mozTransitionEnd'
        };
        let root = document.documentElement;
        for (let name in transitions) {
            if (root.style[name] !== undefined) {
                return transitions[name];
            }
        }
        return false;
    }

    support3d(){
        if (!window.getComputedStyle) {
            return false;
        }
        let el = document.createElement('div'),
            has3d,
            transform = this.supportCSS3('transform');

        document.body.insertBefore(el, null);

        el.style[transform] = 'translate3d(1px,1px,1px)';
        has3d = getComputedStyle(el)[transform];

        document.body.removeChild(el);

        return (has3d !== undefined && has3d.length > 0 && has3d !== "none");
    }

    throttle(func, wait, options){
        let context, args, result;
        let timeout = null;
        let previous = 0;
        if (!options) options = {};
        let later = function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function() {
            let now = Date.now();
            if (!previous && options.leading === false) previous = now;
            let remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    }

    _dimmensions(){
        this.slideWidth = this.$container.outerWidth();
        this.sliderWidth = this.slideLen * this.slideWidth;

        this.$slide.css('width', this.slideWidth);
        this.sliderStyle['width'] = this.sliderWidth + 'px';
    }

    _responsive(){
        if(this.$container == null) return false;

        if (this.timer) clearInterval(this.timer);
        this._dimmensions();

        this.offset = -(this.slideWidth * this.current);
        this._move(this.offset);

        this.defaults.autoPlay && this._autoPlay();

    }

    _controls(){
        const that = this;

        this.$controlPanel = $('<div/>', {
            'class': 'slider-nav'
        }).appendTo(this.$container);

        let links = [];

        for (let i = 0; this.slideLen > i; i++) {
            let act = (this.current === i) ? 'is-active' : '';
            links.push('<a class="slider-nav__control ' + act + '" data-slider-control="' + i + '"></a>');
        }
        this.$controlPanel.html(links.join(''));
        this.$navControl = this.$controlPanel.find('.slider-nav__control');
        this.$controlPanel.on('click.slider', '.slider-nav__control', function(e) {
            e.preventDefault();
            if ($(this).hasClass('is-active')) return;
            that.show(parseInt(this.getAttribute('data-slider-control'), 10));
        });
    }

    _touchEnable(){
        const that = this;

        this.$slider.addClass('has-touch');
        let touchX,
            touchY,
            delta,
            target;

        this.$slider.on(this.ownTouch.event().start + '.slider', function(e) {
            if (that.touchFlag || that.busy) return;

            let touch;
            if (e.originalEvent.targetTouches) {
                target = e.originalEvent.targetTouches[0].target;
                touch = e.originalEvent.targetTouches[0];
            } else {
                touch = e.originalEvent;
                e.preventDefault();
            }

            delta = 0;
            touchX = touch.pageX || touch.clientX;
            touchY = touch.pageY || touch.clientY;
            that.touchFlag = true;

        });
        this.$slider.on(this.ownTouch.event().move + '.slider', function(e) {
            if (!that.touchFlag) return;

            let touch;
            if (e.originalEvent.targetTouches) {
                if (e.originalEvent.targetTouches.length > 1 || target !== e.originalEvent.targetTouches[0].target) {
                    return;
                }
                touch = e.originalEvent.targetTouches[0];
            } else {
                e.preventDefault();
                touch = e.originalEvent;
            }

            let currentX = touch.pageX || touch.clientX;
            let currentY = touch.pageY || touch.clientY;

            if (Math.abs(touchX - currentX) >= Math.abs(touchY - currentY)) {
                delta = touchX - currentX;
                that._move(parseInt(that.offset, 10) - delta);
            }
        });
        this.$slider.on(this.ownTouch.event().end + '.slider', function(e) {
            if (!that.touchFlag) return;
            let swipeTo = delta < 0 ? that.current - 1 : that.current + 1;

            if (Math.abs(delta) < 50 || (!that.defaults.infinite && (swipeTo > that.slideLen - 1 || swipeTo < 0))) {
                that.touchFlag = false;
                that._move(that.offset, true);
                return;
            }
            that.touchFlag = false;
            target = null;
            that.show(swipeTo);
        });
        this.$slider.on(this.ownTouch.event().leave + '.slider', function() {
            if (that.touchFlag) {
                that._move(that.offset, true);
                that.touchFlag = false;
            }
        });
    }

    show(slide){
        if (this.busy) return;
        if (slide === this.current) return;
        this.current = (slide > this.slideLen - 1) ? 0 : slide;
        if (slide < 0) {
            this.current = this.slideLen - 1;
        }

        if (!this.defaults.infinite) {

            this.$arrows.attr('disabled', false);
            if (slide === this.slideLen - 1) {
                this._stopInfinite('next');
            }

            if (this.current === 0) {
                this._stopInfinite('prev');
            }

        }

        this.offset = -(this.slideWidth * (this.current));

        if (this.defaults.controls) {
            this.$navControl.removeClass('is-active')
                .eq(this.current)
                .addClass('is-active');
        }
        this.busy = true;
        this._move(this.offset, true);

        this._triggerChange();
    }

    _move(value, hasAnimate){
        const that = this;

        if (this.transitionProperty && this.transformProperty) {

            (hasAnimate) ?
                this.sliderStyle[this.transitionProperty] = this.transformProperty + ' ' + this.defaults.speed + 'ms ' + this.defaults.cssEase: this.sliderStyle[this.transitionProperty] = "none";

            (this.has3d) ?
                this.sliderStyle[this.transformProperty] = 'translate3d(' + value + 'px, 0, 0)': this.sliderStyle[this.transformProperty] = 'translateX(' + value + 'px)';

            if (hasAnimate) {
                this.$slider.one(that.transitionEnd(), function(e) {
                    that.busy = false;
                });
            } else {
                this.busy = false;
            }
        } else {
            if (hasAnimate) {
                this.$slider.animate({
                    'margin-left': value
                }, this.defaults.speed, 'linear', function() {
                    that.busy = false;
                });
            } else {
                this.$slider.css('margin-left', value);
                this.busy = false;
            }

        }
    }

    // Change event trigger
    _triggerChange(){
        let eventSlide = $.Event('changeSlide.slider', {
            currentSlide: this.current
        });
        this.$container.trigger(eventSlide);
    }

    _autoPlay(){
        const that = this;

        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
            if (!that.touchFlag) {
                that.show(that.current + 1);
            }
        }, ownDelay);
    }

    _stopInfinite(direction){
        this.$container.find('.slider__switch--' + direction).attr('disabled', true);
    }

    destroy(){
        this.sliderStyle['width'] = '';
        this.sliderStyle[this.transformProperty] = '';
        this.sliderStyle[this.transitionProperty] = '';
        this.$slide.css('width', '');
        if (this.defaults.autoPlay) {
            if (this.timer) clearInterval(this.timer);
            this.$container.off('mouseenter.slider');
            this.$container.off('mouseleave.slider');
        }
        if (this.defaults.arrows) {
            this.$arrows.off('click.slider');
            this.$arrows.attr('disabled', false);
        }
        if (this.defaults.controls) {
            this.$controlPanel.off('click.slider').remove();
        }

        this.$caption.attr('disabled', false);

        if (this.defaults.touch) {
            this.$slider
                .removeClass('has-touch')
                .off(this.ownTouch.event().start + '.slider')
                .off(this.ownTouch.event().move + '.slider')
                .off(this.ownTouch.event().end + '.slider')
                .off(this.ownTouch.event().leave + '.slider');
            this.touchFlag = false;
        }
        if (this.defaults.responsive) {
            $(window).off('resize.slider');
        }
        this.$container.removeData("slider");
        this.$container = null;
        this.$slider = null;
        this.$arrows = null;
        this.$caption = null;
        this.$slide = null;
        this.$controlPanel = null;
        this.$navControl = null;
        this.sliderStyle = null;
        this.slideLen = null;
        this.slideWidth = null;
        this.sliderWidth = null;
        this.current = null;
        this.offset = null;
        this.busy = null;
        this.timer = null;
        this.has3d = null;
        this.busy = false;
        this.transformProperty = null;
        this.transitionProperty = null;
        this.enabled = false;
    }
}